import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffTotalJourneys(id: number) {
  return restApiClient
    .url(constructApiUrl(API.staffs.getStaffTotalJourneys.url, { id }))
    .get<number>()
}
